"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummonersTrickeryAbilityHandler = exports.SummonersTrickeryActorAbilityFactory = exports.SummonersTrickeryAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class SummonersTrickeryAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SummonersTrickery;
        this.__typeName = "SummonersTrickery";
    }
}
exports.SummonersTrickeryAbilityArgs = SummonersTrickeryAbilityArgs;
let SummonersTrickeryActorAbilityFactory = class SummonersTrickeryActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SummonersTrickery", "OneEnemies", 0);
    }
};
SummonersTrickeryActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SummonersTrickery")
], SummonersTrickeryActorAbilityFactory);
exports.SummonersTrickeryActorAbilityFactory = SummonersTrickeryActorAbilityFactory;
let SummonersTrickeryAbilityHandler = class SummonersTrickeryAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new core_1.LinkedEffectsEffectArgs([
                        enums_1.AttributeType.NatureDamageImmunity,
                        enums_1.AttributeType.FireDamageImmunity,
                        enums_1.AttributeType.FrostDamageImmunity,
                        enums_1.AttributeType.SonicDamageResistance,
                    ].map(attr => new core_1.MaxAttributeDecreaseEffectArgs(attr, 5)), true),
                    duration: Duration_1.Duration.Instant,
                    onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "CelestialLightPillar"))
                });
            }
        });
    }
};
SummonersTrickeryAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SummonersTrickery)
], SummonersTrickeryAbilityHandler);
exports.SummonersTrickeryAbilityHandler = SummonersTrickeryAbilityHandler;
